import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-column flex-min-height-0" }
const _hoisted_2 = {
  key: 1,
  class: "w-100 h-100 fs-1 text-danger d-flex align-items-center justify-content-center flex-column"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle missingContextIcon" }, null, -1)
const _hoisted_4 = { class: "d-flex flex-column gap-3" }
const _hoisted_5 = { class: "d-flex flex-column gap-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(":")
const _hoisted_10 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  type: "button",
  class: "btn btn-primary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainMenu = _resolveComponent("MainMenu")!
  const _component_ContextLine = _resolveComponent("ContextLine")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_InfoMessageDisplayWidget = _resolveComponent("InfoMessageDisplayWidget")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_NewPasswordWidget = _resolveComponent("NewPasswordWidget")!
  const _component_RequestUserPolicyWidget = _resolveComponent("RequestUserPolicyWidget")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainMenu, {
      activeEntry: this.section,
      ref: "mainMenu",
      infoMessages: _ctx.ctx.infoMessages,
      onOpenInfoMessages: _ctx.openInfoMessages,
      onOpenAbout: _ctx.openAbout,
      onMenuButtonClicked: _ctx.increaseViewKey
    }, null, 8, ["activeEntry", "infoMessages", "onOpenInfoMessages", "onOpenAbout", "onMenuButtonClicked"]),
    _createVNode(_component_ContextLine, {
      onContextChange: this.contextChanged
    }, null, 8, ["onContextChange"]),
    _createVNode(_component_router_view, { key: _ctx.viewKey }, {
      default: _withCtx(({ Component }) => [
        (_ctx.ctx.contextLevel <= _ctx.actualContextLevel)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: 0,
              ref: "componentRef",
              onIframeReloaded: _ctx.increaseViewKey
            }, null, 8, ["onIframeReloaded"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_ctx.actualContextLevel === _ctx.ContextLevel.NONE)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('contextLine.missingNetwork')), 1)
                  ], 64))
                : (_ctx.actualContextLevel === _ctx.ContextLevel.NETWORK)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('contextLine.missingProject')), 1)
                    ], 64))
                  : (_ctx.actualContextLevel === _ctx.ContextLevel.PROJECT)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('contextLine.missingSubProject')), 1)
                      ], 64))
                    : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_Dialog, {
      ref: "infoDialog",
      lazy: "",
      title: _ctx.$t('app.infoMessagesDialogTitle'),
      buttons: _ctx.CLOSE,
      extraClasses: "modal-dialog-centered modal-lg"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.ctx.infoMessages, (infoMessage) => {
            return (_openBlock(), _createBlock(_component_InfoMessageDisplayWidget, {
              key: infoMessage.id,
              infoMessage: infoMessage
            }, null, 8, ["infoMessage"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title", "buttons"]),
    _createVNode(_component_Dialog, {
      ref: "aboutDialog",
      lazy: "",
      title: _ctx.$t('about.infoName'),
      buttons: _ctx.CLOSE,
      maximize: false,
      extraClasses: "modal-dialog-centered modal-lg"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("about.infoVersionLabel")), 1),
                _hoisted_6
              ]),
              _createElementVNode("td", null, _toDisplayString(this.ctx.versionInfo.bundleVersion), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("about.infoRevisionLabel")), 1),
                _hoisted_7
              ]),
              _createElementVNode("td", null, _toDisplayString(this.ctx.versionInfo.svnVersion), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("about.infoDateLabel")), 1),
                _hoisted_8
              ]),
              _createElementVNode("td", null, _toDisplayString(this.ctx.versionInfo.buildTimeStamp), 1)
            ]),
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createElementVNode("b", null, _toDisplayString(_ctx.$t("about.infoDeveloperLabel")), 1),
                _hoisted_9
              ]),
              _createElementVNode("td", null, _toDisplayString(_ctx.$t("about.infoDeveloper")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["title", "buttons"]),
    _createVNode(_component_Dialog, {
      ref: "newPasswordDialog",
      lazy: "",
      form: "",
      title: _ctx.$t('app.newPasswordTitle'),
      extraClasses: "modal-lg"
    }, {
      dialogWrapper: _withCtx(({ vnode, submit }) => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(vnode), {
          onSubmit: _withModifiers(($event: any) => (_ctx.$refs.newPasswordWidget.submit().then(success => success ? submit(null) : void 0)), ["prevent"]),
          novalidate: ""
        }, null, 8, ["onSubmit"]))
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$t('general.abort')), 1),
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-primary",
          disabled: _ctx.newPasswordInvalid
        }, _toDisplayString(_ctx.$t('app.newPasswordLabel')), 9, _hoisted_11)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_NewPasswordWidget, {
          ref: "newPasswordWidget",
          "onUpdate:invalid": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newPasswordInvalid = $event))
        }, null, 512)
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_Dialog, {
      ref: "requestUserPolicyDialog",
      lazy: "",
      title: _ctx.$t('app.requestUserPolicyTitle')
    }, {
      buttons: _withCtx(() => [
        _createElementVNode("button", _hoisted_12, _toDisplayString(_ctx.$t('general.close')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_RequestUserPolicyWidget)
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}